import { useEffect } from 'react';
import Lenis from 'lenis';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * Lenis smooth scroll — synced with GSAP ticker for accurate ScrollTrigger.
 * Tuned for a premium, cinematic feel: slightly slower duration, expo easing.
 */
export const useSmoothScroll = () => {
    useEffect(() => {
        const lenis = new Lenis({
            duration: 1.25,
            easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
            smoothWheel: true,
            wheelMultiplier: 0.9,
            touchMultiplier: 1.1,
            infinite: false,
        });

        const raf = (time) => lenis.raf(time * 1000);
        gsap.ticker.add(raf);
        gsap.ticker.lagSmoothing(0);

        lenis.on('scroll', ScrollTrigger.update);

        return () => {
            gsap.ticker.remove(raf);
            lenis.destroy();
        };
    }, []);
};
